export default {
  init() {
    $('.testimonies-slider').slick({
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      arrows: true,
      infinite: true,
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js